import './SpellListPage.scss';
import { List, Page, Row, SearchInput, SpellListItem, Breadcrumb, Filters } from '../../components';
import { SPELLS } from '../../data';
import { useContext, useEffect, useState } from 'react';
import { applyAllFilters } from '../../util/spell';
import { getSpellId } from '../../util/spell';
import { SettingsContext } from '../../context';
import { useNavigate, useParams } from 'react-router-dom';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { Button } from '@mui/material';

export const SpellListPage = () => {
    const {listId } = useParams();
    const [ list, setList ] = useState(null);
    const navigate = useNavigate();

    const [ searchString, setSearchString ] = useState('');
    const [ filters, setFilters ] = useState({});
    const settings = useContext(SettingsContext);

    useEffect(() => {
        if(listId) {
            const docRef = doc(db, "spellLists", listId);

            getDoc(docRef).then(docSnap => {
                setList(docSnap.data())
            });
        }
    }, [listId]);

    const compareSpells = (s1, s2) => {
        if (s1.level === s2.level) {
            return s1.name.localeCompare(s2.name);
        }
    
        return s1.level - s2.level;
    };

    const listSpells = () => {
        return SPELLS
            .filter(s => list?.spells.includes(getSpellId(s)));
    };

    const filteredSpells = () => {
        const regex = new RegExp(searchString.toLowerCase());

        return listSpells()
            .filter(({ name }) => regex.test(name.toLowerCase()))
            .filter(s => applyAllFilters(s, filters, settings))
            .sort(compareSpells);
    }

    return (
        <Page className="SpellListPage">
            <Breadcrumb />
            {list && 
                <>
                    <div className="pageHeader">
                        <Row>
                            <h2>{list.name}'s list</h2>
                            <Button variant="contained" color="secondary" onClick={() => navigate('edit')}>Edit</Button>
                        </Row>
                        <SearchInput 
                            onChange={setSearchString}
                            value={searchString}
                        />
                    </div>
                    <Filters filters={filters} onChange={setFilters} />
                </>
            }
            <List>
                {!list &&
                    <Row className="empty">No spell list selected</Row>
                }
                {list && !listSpells().length &&
                    <Row className="empty">Nothing has been added to this list</Row>
                }
                {filteredSpells().map((spell, i) => (
                    <SpellListItem 
                        key={i} 
                        spell={spell} 
                    />
                ))}
            </List>
        </Page>
    );
};